const datosEstados = {
  amazonas: {
    tipo: 'Asesores de venta',
    name: 'Ventas',
    telefonos: ['+58 424 8263880'],
    alias: 'Amazonas',
  },
  anzoategui: {
    tipo: 'Asesores de venta',
    name: 'Antonio García',
    telefonos: ['+58 426 5832296'],
    alias: 'Anzoátegui',
  },
  apure: {
    tipo: 'Asesores de venta',
    name: 'Ventas',
    telefonos: ['+58 424 8263880'],
    alias: 'Apure',
  },
  aragua: {
    tipo: 'Asesores de venta',
    name: 'Arianna López/Manuel Lovera',
    telefonos: ['+58 414 4124396', '+58 412 5382891'],
    alias: 'Aragua',
  },
  barinas: {
    tipo: 'Asesores de venta',
    name: 'Daviana Salas',
    telefonos: ['+58 424 5615091'],
    alias: 'Barinas',
  },
  bolivar: {
    tipo: 'Asesores de venta',
    name: 'Antonio García',
    telefonos: ['+58 426 5832296'],
    alias: 'Bolívar',
  },
  carabobo: {
    tipo: 'Asesores de venta',
    name: 'Arianna López/Manuel Lovera',
    telefonos: ['+58 414 4124396', '+58 412 5382891'],
    alias: 'Carabobo',
  },
  cojedes: {
    tipo: 'Asesores de venta',
    name: 'Humberto García',
    telefonos: ['+58 424 4308284'],
    alias: 'Cojedes',
  },
  deltaamacuro: {
    tipo: 'Asesores de venta',
    name: 'Ventas',
    telefonos: ['+58 424 8263880'],
    alias: 'Delta Amacuro',
  },
  caracas: {
    tipo: 'Asesores de venta',
    name: 'Juan Sandoval/Keiver Maestre',
    telefonos: ['+58 424 1132089', ' +58 424 1898894'],
    alias: 'Caracas',
  },
  falcon: {
    tipo: 'Asesores de venta',
    name: 'Pedro Sánchez/Evelyn Pirela/María Suárez',
    telefonos: ['+58 414 2927816', '+58 414 6865205', '+58 412 2291629'],
    alias: 'Falcón',
  },
  guarico: {
    tipo: 'Asesores de venta',
    name: 'Arianna López/Manuel Lovera',
    telefonos: ['+58 414 4124396', '+58 412 5382891'],
    alias: 'Guárico',
  },
  vargas: {
    tipo: 'Asesores de venta',
    name: 'Juan Sandoval/Keiver Maestre',
    telefonos: ['+58424 1132089', '+58424 1898894'],
    alias: 'La Guaira', // Alias personalizado
  },
  lara: {
    tipo: 'Asesores de venta',
    name: 'Daviana Salas',
    telefonos: ['+58 424 5615091'],
    alias: 'Lara',
  },
  merida: {
    tipo: 'Asesores de venta',
    name: 'Ricardo Mejía',
    telefonos: ['+58 424 7689442'],
    alias: 'Mérida',
  },
  miranda: {
    tipo: 'Asesores de venta',
    name: 'Juan Sandoval/Keiver Maestre',
    telefonos: ['+58424 1132089', '+58424 1898894'],
    alias: 'Miranda',
  },
  monagas: {
    tipo: 'Asesores de venta',
    name: 'Antonio García',
    telefonos: ['+58 426 5832296'],
    alias: 'Monagas',
  },
  nuevaesparta: {
    tipo: 'Asesores de venta',
    name: 'Ventas',
    telefonos: ['+58 424 8263880'],
    alias: 'Nueva Esparta',
  },
  portuguesa: {
    tipo: 'Asesores de venta',
    name: 'Ventas',
    telefonos: ['+58 424 8263880'],
    alias: 'Portuguesa',
  },
  sucre: {
    tipo: 'Asesores de venta',
    name: 'Antonio García',
    telefonos: ['+58 426 5832296'],
    alias: 'Sucre',
  },
  tachira: {
    tipo: 'Asesores de venta',
    name: 'Ricardo Mejía',
    telefonos: ['+58 424 7689442'],
    alias: 'Táchira',
  },
  zulia: {
    tipo: 'Asesores de venta',
    name: 'Pedro Sánchez/Evelyn Pirela/María Suárez',
    telefonos: ['+58 414 2927816', '+58 414 6865205', '+58 412 2291629'],
    alias: 'Zulia',
  },
  yaracuy: {
    tipo: 'Asesores de venta',
    name: 'Ventas',
    telefonos: ['+58 424 8263880'],
    alias: 'Yaracuy',
  },
  trujillo: {
    tipo: 'Asesores de venta',
    name: 'Daviana Salas',
    telefonos: ['+58 424 5615091'],
    alias: 'Trujillo',
  },
};

// Array de estados (derivado de las claves de datosEstados)
export const estados = Object.keys(datosEstados);

// Función helper para obtener la lista de estados (array) - para uso dinámico si es necesario
export const getEstados = () => Object.keys(datosEstados);

// Función helper para obtener el alias de un estado
export const getEstadoAlias = estado => {
  return datosEstados[estado]?.alias || estado;
};

// Objeto helper para compatibilidad con código existente (estadoAlias[estado])
export const estadoAlias = new Proxy(
  {},
  {
    get: (target, prop) => getEstadoAlias(prop),
  }
);

export default datosEstados;
